import { useState, useEffect, useRef } from "react";
// import "../src/assets/components/requestupdatepage.css";
import "../src/assets/components/global.css";
import { useParams, useNavigate } from "react-router-dom";
import Webcam from "react-webcam"; // Ensure you have installed react-webcam
import AutoLogout from "./autologout";
import axios from "axios";
import Swal from "sweetalert2";

function RequestUpdatepage() {
  //   const [userInfo, setUserInfo] = useState({});
  const { brgyId } = useParams();
  const [firstname, setFirstname] = useState("");
  const [middlename, setMiddlename] = useState("");
  const [lastname, setlastname] = useState("");
  const [age, setAge] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [gender, setGender] = useState("");
  const [cellnumber, setCellnumber] = useState("");
  const [civilstatus, setCivilstatus] = useState("Single");
  const [religion, setReligion] = useState("N/A");
  const [nationality, setNationality] = useState("");
  const [occupation, setOccupation] = useState("");
  const [recentaddress, setRecentaddress] = useState("");
  const [presentaddress, setPresentaddress] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const [photo, setPhoto] = useState("");
  // const [photoTaken, setPhotoTaken] = useState(false);
  const [hasCamera, setHasCamera] = useState(true);
  const webcamRef = useRef(null);
  const [cameraDeviceId, setCameraDeviceId] = useState(null);
  const [updatingPhoto, setUpdatingPhoto] = useState(false);
  // const [personaldata, setPersonalInfo] = useState({});
  // const [usersdata, setUserinfo] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make an API call to fetch user information based on brgyId
        const response = await axios.get(
          `https://brgytracerappserver.onrender.com/requestUpdatepage/${brgyId}`
        );

        // Check if response.data is not undefined or null
        if (response.data) {
          const { personalinfo, usersinfo } = response.data; // Destructure personalinfo and usersinfo from response data

          // Access personal information
          if (personalinfo && personalinfo.length > 0) {
            console.log("checking data:", personalinfo);
            // Set state values for personal information
            setFirstname(personalinfo[0].firstname);
            console.log("checfname", personalinfo[0].firstname);
            setMiddlename(personalinfo[0].middlename);
            setlastname(personalinfo[0].lastname);
            setAge(personalinfo[0].age);
            setBirthdate(personalinfo[0].birthdate);
            setGender(personalinfo[0].gender);
            console.log("checfname", setGender);
            setCellnumber(personalinfo[0].cellnumber);
            setCivilstatus(personalinfo[0].civilstatus);
            setReligion(personalinfo[0].religion);
            setNationality(personalinfo[0].nationality);
            setOccupation(personalinfo[0].occupation);
            setRecentaddress(personalinfo[0].recentaddress);
            setPresentaddress(personalinfo[0].presentaddress);
            setPhoto(personalinfo[0].photo);
          }
          // Access user information
          if (usersinfo && usersinfo.length > 0) {
            // Set state values for user information
            setUsername(usersinfo[0].username);
            setEmail(usersinfo[0].email);
            setPassword(usersinfo[0].password);
            setRole(usersinfo[0].role);
          }
        } else {
          console.error("No data received from the server");
        }
      } catch (error) {
        console.error("Error fetching user information:", error);
      }
    };

    fetchData(); // Call the fetchData function when the component mounts
  }, [brgyId]); // Re-run the effect when brgyId changes

  const handlesendrequest = async (event) => {
    event.preventDefault();
    const updatedCivilStatus = civilstatus || "Single";
    const requestData = {
      brgyId,
      firstname,
      middlename,
      lastname,
      age,
      birthdate,
      gender,
      cellnumber,
      civilstatus: updatedCivilStatus,
      religion,
      nationality,
      occupation,
      recentaddress,
      presentaddress,
      username,
      email,
      password,
      role,
      photo,
    };

    console.log("Sending data to Firebase:", requestData);

    try {
      // Make a POST request to the server to handle registration
      const response = await axios.post(
        "https://brgytracerappserver.onrender.com/requestUpdatepage",
        requestData
      );
      const data = response.data;

      // Handle the response from the server
      console.log(data);
      if (data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "You've Send Request",
          showConfirmButton: true,
        }).then(() => {
          window.location.reload();
        });

        // Delay reloading the page for better user experience
      } else if (data.status === "failed") {
        // data.message.includes("already exists")
        // Display an alert if brgyId already exists
        Swal.fire({
          icon: "error",
          title: "Request Failed",
          text: "your request is not already reviewed",
          showConfirmButton: false,
        });
      } else {
        // Handle other error scenarios
        Swal.fire({
          icon: "error",
          title: "Something went wrong!",
          text: "System error!!",
        });
      }
    } catch (error) {
      // Handle error response
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        text: "System error!!",
      });
    }
  };

  const handleCancel = () => {
    navigate(`/myinfo/${brgyId}`);
  };

  const capturePhoto = async () => {
    if (webcamRef.current) {
      const screenshot = webcamRef.current.getScreenshot();
      setPhoto(screenshot);
      // setPhotoTaken(true);
      setUpdatingPhoto(false);
    }
  };

  const checkCamera = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(
        (device) => device.kind === "videoinput"
      );
      if (videoDevices.length > 0) {
        setHasCamera(true);
        setCameraDeviceId(videoDevices[0].deviceId);
      } else {
        setHasCamera(false);
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
      setHasCamera(false);
    }
  };

  useEffect(() => {
    checkCamera();
  }, []);

  const handleUpdatePhoto = () => {
    if (hasCamera) {
      setUpdatingPhoto(true);
    } else {
      Swal.fire({
        icon: "error",
        title: "No Camera Detected",
        text: "No camera was found on your device.",
      });
    }
  };

  return (
    <div className="requestupdate-parent">
      <AutoLogout />
      <div className="requestform-box wrap parent-height">
        <form className="formUpdate-boxcontainer" onSubmit={handlesendrequest}>
          <h1>Apply Update form</h1>
          <div className="autonumbers">
            <label>BrgyId:{brgyId}</label>
          </div>
          <div className="content-container">
            <div className="webcam-container">
              {photo ? (
                <div className="photo-preview">
                  <img src={photo} alt="User" />
                </div>
              ) : (
                <div className="no-photo">No photo available</div>
              )}
              <button
                type="button"
                onClick={handleUpdatePhoto}
                className="button-update-photo">
                Update Photo
              </button>
              {updatingPhoto && hasCamera && (
                <div className="webcam-holder">
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width={300}
                    height={300}
                    videoConstraints={{ deviceId: cameraDeviceId }}
                  />
                  <button
                    type="button"
                    onClick={capturePhoto}
                    className="button-capture">
                    Capture
                  </button>
                </div>
              )}
            </div>
            <label>Account Information</label>
            <div className="accountbox-container">
              <div>
                <label htmlFor="username">Username:</label>
                <input
                  type="text"
                  placeholder="Enter Username"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div>
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Enter Email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="password">Password:</label>
                <input
                  type="password"
                  placeholder="Enter Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div>
                <label>Role:</label>
                <select value={role} onChange={(e) => setRole(e.target.value)}>
                  <option value="member">Member</option>
                  <option value="officer">Officer</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            </div>
            <label>User Information</label>
            <div className="userinfo-container">
              <div>
                <label htmlFor="firstname">First name:</label>
                <input
                  type="text"
                  placeholder="Enter Firstname"
                  required
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="middlename">Middle Name:</label>
                <input
                  type="text"
                  placeholder="Enter Middle Name"
                  required
                  value={middlename}
                  onChange={(e) => setMiddlename(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="lastname">Last Name:</label>
                <input
                  type="text"
                  placeholder="Enter Last Name"
                  required
                  value={lastname}
                  onChange={(e) => setlastname(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="age">Age:</label>
                <input
                  type="text"
                  placeholder="Enter Age"
                  required
                  value={age}
                  min="0" // Specify minimum age
                  maxLength={3} // Set the maximum length to 3
                  pattern="[0-9]*" // Allow only numeric values
                  onKeyPress={(e) => {
                    // Allow only numeric characters and the Enter key
                    if (isNaN(e.key) && e.key !== "Enter") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    // Remove non-numeric characters
                    const numericValue = e.target.value.replace(/[^0-9]/g, "");

                    // Update the state with the numeric value
                    setAge(numericValue);
                  }}
                />
              </div>
              <div>
                <label htmlFor="Birth-Date">Birth Date:</label>
                <input
                  type="date"
                  placeholder="Enter Birth-Date"
                  required
                  value={birthdate}
                  onChange={(e) => setBirthdate(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="Gener">Gender:</label>
                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}>
                  <option value="Other">Other</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Lesbian">Lesbian</option>
                </select>
              </div>
              <div>
                <label htmlFor="phoneNumber">Phone Number:</label>
                <input
                  type="text"
                  placeholder="Enter Phone Number"
                  required
                  pattern="[0-9]{4} [0-9]{3} [0-9]{4}"
                  value={cellnumber}
                  onChange={(e) => {
                    const formattedValue = e.target.value.replace(
                      /[^0-9 ]/g,
                      ""
                    );

                    // Update the state with the formatted value
                    setCellnumber(formattedValue);
                  }}
                />
                <small>Format: 0000 000 0000</small>
              </div>
              <div>
                <label htmlFor="civilstatus">Civil Status:</label>
                <select
                  value={civilstatus}
                  onChange={(e) => setCivilstatus(e.target.value)}>
                  <option value="Single">Single</option>
                  <option value="Married">Married</option>
                  <option value="Widowed">Widowed</option>
                  <option value="Separated">Separated</option>
                  <option value="Divorced ">Divorced</option>
                  <option value="Annulled ">Annulled</option>
                </select>
              </div>
              <div>
                <label htmlFor="religion">Religion:</label>
                <select
                  value={religion}
                  onChange={(e) => setReligion(e.target.value)}>
                  <option value="Other">Other</option>
                  <option value="Roman Catholic">Roman Catholic</option>
                  <option value="Iglesia ni Cristo">INC</option>
                  <option value="Evangelicals">Evangelicals</option>
                  <option value="Baptists">Baptists</option>
                  <option value="Methodists">Methodists</option>
                  <option value="Seventh-day Adventists">SDA</option>
                  <option value="Pentecostals">Pentecostals</option>
                  <option value="Jehovah's Witnesses">
                    Jehovah's Witnesses
                  </option>
                  <option value="Assemble of God">Assemble of God</option>
                </select>
              </div>
              <div>
                <label htmlFor="Nationality">Nationality:</label>
                <select
                  value={nationality}
                  onChange={(e) => setNationality(e.target.value)}>
                  <option value="Filipino">Filipino</option>
                  <option value="American">American</option>
                  <option value="Chinese">Chinese</option>
                  <option value="Japanese">Japanese</option>
                  <option value="Korean">Korean</option>
                  <option value="Indian">Indian</option>
                  <option value="Australian">Australian</option>
                  <option value="British">British</option>
                  <option value="Ohter">Ohter</option>
                </select>
              </div>
              <div>
                <label htmlFor="occupation">Occupation:</label>
                <select
                  value={occupation}
                  onChange={(e) => setOccupation(e.target.value)}>
                  <option value="None">None</option>
                  <option value="Labor">Labor</option>
                  <option value="HouseWife">HouseWife</option>
                  <option value="Teacher">Teacher</option>
                  <option value="Principal">Principal</option>
                  <option value="Professor">Professor</option>
                  <option value="Librarian">Librarian</option>
                  <option value="Special Education Teacher">
                    Special Education Teacher
                  </option>
                  <option value="Academic Advisor">Academic Advisor</option>
                  <option value="Software Engineer">Software Engineer</option>
                  <option value="Mechanical Engineer">
                    Mechanical Engineer
                  </option>
                  <option value="Civil Engineer">Civil Engineer</option>
                  <option value="Electrical Engineer">
                    Electrical Engineer
                  </option>
                  <option value="Chemical Engineer">Chemical Engineer</option>
                  <option value="Biomedical Engineer">
                    Biomedical Engineer
                  </option>
                  <option value="Data Scientist">Data Scientist</option>
                  <option value="Network Administrator">
                    Network Administrator
                  </option>
                  <option value="IT Support Specialist">
                    IT Support Specialist
                  </option>
                  <option value="Systems Analyst">Systems Analyst</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Nurse">Nurse</option>
                  <option value="Pharmacist">Pharmacist</option>
                  <option value="Physical Therapist">Physical Therapist</option>
                  <option value="Medical Technologist">
                    Medical Technologist
                  </option>
                  <option value="Radiologic Technologist">
                    Radiologic Technologist
                  </option>
                  <option value="Occupational Therapist">
                    Occupational Therapist
                  </option>
                  <option value="Accountant">Accountant</option>
                  <option value="Financial Advisor">Financial Advisor</option>
                  <option value="Marketing Manager">Marketing Manager</option>
                  <option value="Sales Manager">Sales Manager</option>
                  <option value="Human Resources Manager">
                    Human Resources Manager
                  </option>
                  <option value="Operations Manager">Operations Manager</option>
                  <option value="Entrepreneur">Entrepreneur</option>
                  <option value="Consultant">Consultant</option>
                  <option value="Project Manager">Project Manager</option>
                  <option value="Farmer">Farmer</option>
                  <option value="Agricultural Scientist">
                    Agricultural Scientist
                  </option>
                  <option value="Agronomist">Agronomist</option>
                  <option value="Veterinarian">Veterinarian</option>
                  <option value="Poultry Farmer">Poultry Farmer</option>
                  <option value="Lawyer">Lawyer</option>
                  <option value="Judge">Judge</option>
                  <option value="Police Officer">Police Officer</option>
                  <option value="Firefighter">Firefighter</option>
                  <option value="Security Guard">Security Guard</option>
                  <option value="Detective">Detective</option>
                  <option value="Forensic Scientist">Forensic Scientist</option>
                  <option value="Graphic Designer">Graphic Designer</option>
                  <option value="Journalist">Journalist</option>
                  <option value="Photographer">Photographer</option>
                  <option value="Electrician">Electrician</option>
                  <option value="Plumber">Plumber</option>
                  <option value="Welder">Welder</option>
                  <option value="Mason">Mason</option>
                  <option value="Construction Manager">
                    Construction Manager
                  </option>
                  <option value="Painter">Painter</option>
                  <option value="Heavy Equipment Operator">
                    Heavy Equipment Operator
                  </option>
                  <option value="HVAC Technician">HVAC Technician</option>
                  <option value="Housekeeper">Housekeeper</option>
                  <option value="Bartender">Bartender</option>
                  <option value="Store Manager">Store Manager</option>
                </select>
              </div>
              <div>
                <label htmlFor="recentaddress">Recentaddress:</label>
                <input
                  type="text"
                  value={recentaddress}
                  required
                  onChange={(e) => setRecentaddress(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="presentaddress">Presentaddress:</label>
                <input
                  type="text"
                  value={presentaddress}
                  required
                  onChange={(e) => setPresentaddress(e.target.value)}
                />
              </div>
            </div>
            <button className="registerbtn" type="submit">
              Send Request
            </button>
            <button
              type="btn"
              className="closebtn"
              onClick={handleCancel} //close the page and back to login page
            >
              X
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RequestUpdatepage;
